"use strict";
/**
  Represents a location in the source file. (The name "location" cannot be used
  because it has a special meaning in browsers.) This is used throughout the
  compiler to map program statements to token positions.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Location = /** @class */ (function () {
    /**
     *
     * @param line
     * @param position
     */
    function Location(line, position) {
        this.line = line;
        this.position = position;
    }
    Location.prototype.toString = function () {
        var line = this.line;
        var position = this.position;
        return line + 1 + ":" + (position + 1);
    };
    return Location;
}());
exports.default = Location;
//# sourceMappingURL=Location.js.map